import { DateTime } from 'luxon';

export interface GetSMTLogsParams {
  patientId: string;
  selectedDate: string; // YYYY-MM-DD
}

export interface DateRange {
  startDate: string;
  endDate: string;
}

export const DEFAULT_DAYS_TO_LOAD = 14;
export const MAX_LOOKBACK_YEARS = 1;

export const getSMTDailyLogsInitialPageParam = (
  selectedDate: string,
): DateRange => {
  const selectedDateTime = DateTime.fromISO(selectedDate);

  const endDate = selectedDateTime.toISODate();
  const startDate = selectedDateTime
    .minus({ days: DEFAULT_DAYS_TO_LOAD - 1 })
    .toISODate();

  if (!endDate || !startDate) {
    throw new Error(`Invalid date: ${selectedDate}`);
  }

  return {
    endDate,
    startDate,
  };
};

export type DailyLogsResponse = DailyLog[];

export const getSMTDailyLogsNextPageParam = (
  _lastPage: DailyLogsResponse,
  _allPages: DailyLogsResponse[],
  lastPageParam: DateRange | undefined,
): DateRange | undefined => {
  // Continue paging backwards even if the current page has no logs (sparse data).
  if (!lastPageParam) return undefined;

  const currentStartDate = DateTime.fromISO(lastPageParam.startDate);
  const maxLookback = DateTime.now().minus({
    years: MAX_LOOKBACK_YEARS,
  });

  // Stop pagination if we've reached the maximum lookback period
  if (currentStartDate < maxLookback) {
    return undefined;
  }

  const endDate = currentStartDate.minus({ days: 1 }).toISODate();
  const startDate = currentStartDate
    .minus({ days: DEFAULT_DAYS_TO_LOAD })
    .toISODate();

  if (!endDate || !startDate) {
    throw new Error(`Invalid date in pagination: ${lastPageParam.startDate}`);
  }

  return {
    endDate,
    startDate,
  };
};
